import SplashScreen from "@/components/SplashScreen";
import { logoutSuccessCallback } from "@/requests/callbacks/user";
import { usePostLogout, useUser } from "@/requests/hooks/user";
import { INTEGRATIONS_CHECKLIST_URL } from "@/utils/const";
import { useQueryClient } from "@tanstack/react-query";
import flagsmith from "flagsmith";
import { useEffect } from "react";
import {
  Navigate,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

interface IProps {
  children: React.ReactNode;
}

const UnprotectedRoute = ({ children }: IProps) => {
  const queryClient = useQueryClient();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const {
    data: user,
    isLoading,
    isSuccess: isGetUserSuccess,
    isRefetching,
  } = useUser();
  const { mutateAsync: logout, isSuccess: isLogoutSuccess } = usePostLogout();

  useEffect(() => {
    if (isLogoutSuccess) logoutSuccessCallback(queryClient, navigate);
  }, [isLogoutSuccess]);

  useEffect(() => {
    if (isGetUserSuccess && flagsmith.identity !== user?.email) {
      flagsmith.identify(user.email);
    }
  }, [isGetUserSuccess]);

  if (searchParams.get("from") === "control_panel") {
    logout();
  }

  const location = useLocation();

  if (isLoading && !isRefetching) return <SplashScreen />;

  if (
    user &&
    location.pathname !== "/auth/company-selector" &&
    location.pathname !== "/auth/login"
  ) {
    return <Navigate to={INTEGRATIONS_CHECKLIST_URL} replace />;
  }

  return children;
};
export default UnprotectedRoute;
